@if (lobLoader) {
<div class="stk-table-loader forecast-add-loader">
  <app-loader> </app-loader>
</div>
} @if (modalType == 'app') {
<div>
  <p class="note-margin note-highlighter">
    <b>Note: </b> Applications which has actuals or forecast already for at least 1 service will not be visible in the
    Application dropdown.
  </p>
</div>
}
<div class="row-new forecast-add-div">
  @if (modalType == 'app') {
  <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3">
    <!-- start -->
    <label class="section-name tabl-header tabl-header-font demographics-app-id-label">
      Select Application
      <span class="mandate-asterisk uitk-icon uitk-icon-asterisk sm-icon"></span>
    </label>
    <mat-form-field appearance="outline">
      <mat-select
        (keydown)="$event.stopPropagation()"
        panelClass="global-select-panel"
        (selectionChange)="showAppAndBillingSegment($event)"
        #askGlobalID="ngModel"
        [(ngModel)]="selectedGloablAppCode"
        placeholder="Select an Application"
      >
        <input
          matinput
          type="text"
          [(ngModel)]="FAGI"
          class="searchoption ps-1 input-field-container"
          placeholder="Search for an Application Name or ID"
          (keydown)="$event.stopPropagation()"
        />
        @for (value of allNewApps | filter: FAGI; track value) {
        <mat-option [value]="value" class="global-mat-option">
          <span>
            <span style="font-weight: bolder;">{{ value.app_id }}</span> / {{ value.long_name }}</span
          >
        </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <!-- end -->
  </div>
  } @if (modalType == 'service') {
  <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4 ">
    <span class="form-inline-new">
      <p class="forecast-service-headers">Application ID</p>
    </span>
    <span>
      <p class="forecast-service-values">{{ dataSource?.ask_global_id }}</p>
    </span>
  </div>
  } @if (appName || dataSource.app_name) {
  <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4 ">
    <span class="form-inline-new">
      <p class="forecast-service-headers">Application Name</p>
    </span>
    <span>
      <p class="forecast-service-values">
        {{ modalType == 'service' ? dataSource?.app_name : appName }}
      </p>
    </span>
  </div>
  } @if (billingSegment || dataSource.Billing_Segment) {
  <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 ">
    <span class="form-inline-new">
      <p class="forecast-service-headers">Billing Segment</p>
    </span>
    <span>
      <p class="forecast-service-values">{{ modalType == 'service' ? dataSource.Billing_Segment : billingSegment }}</p>
    </span>
  </div>
  }
</div>
<div class="row-new forecast-add-div">
  <div class="col-md-2 col-sm-2 col-lg-2 col-xl-2 col-xs-2 ">
    <div class="form-group ">
      <span class="opid form-inline" for="groupname">
        <p style="color: #013b71;font-weight: bold;" matTooltipPosition="above" [matTooltip]="internationalTooltipMsg">
          International <b class="text-danger">*</b>
        </p>
      </span>
      <section class="tp-section radio-btn-section" style="width: 90%;">
        <mat-radio-group
          class="forecast-add-radio-buttons"
          [(ngModel)]="internationalService"
          (change)="serviceTypeChange()"
        >
          <mat-radio-button
            color="primary"
            value="true"
            [checked]="internationalService == 'true'"
            style="margin-right: 10%"
          >
            Yes
          </mat-radio-button>
          <mat-radio-button color="primary" value="false" [checked]="internationalService == 'false'">
            No
          </mat-radio-button>
        </mat-radio-group>
      </section>
    </div>
  </div>
  <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 ">
    <div class="form-group ">
      <span class="opid form-inline" for="groupname">
        <p style="color: #013b71;font-weight: bold;">Service Name <b class="text-danger">*</b></p>
      </span>
      <section class="tp-section select-service" style="width: 90%;">
        <mat-form-field appearance="outline" class="custom-dropdown">
          <mat-select
            panelClass="global-select-panel"
            placeholder="Please Select Service"
            [(ngModel)]="selectedService"
            (selectionChange)="serviceChange($event)"
            [disabled]="internationalService == '' || internationalService == null"
          >
            <input
              matInput
              type="text"
              [placeholder]="serviceSearch == '' ? 'Search' : ''"
              [(ngModel)]="serviceSearch"
              (keyup)="searchService($event)"
              class="service-search mat-input-search w-100"
              (keydown)="$event.stopPropagation()"
              appDisableDragDrop
            />
            @for (service of servicesData; track service) {
            <mat-option
              style="cursor: pointer !important; pointer-events: auto !important"
              class="dropDownList"
              [value]="service"
              [disabled]="service.disabled"
              [title]="
                service.disabled
                  ? service.Edit_TOH == 'No'
                    ? 'Not Editable from TechOps'
                    : 'Service Already Exists'
                  : ''
              "
            >
              <label>
                {{ service?.Service_Name }}
              </label>
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </section>
    </div>
  </div>
  <div class="col-md-2 col-sm-2 col-lg-2 col-xl-2 col-xs-2 ">
    <span class="form-inline-new">
      <p class="forecast-service-headers">Service Id</p>
    </span>
    <span>
      <p class="forecast-service-values">{{ selectedService?.Service }}</p>
    </span>
  </div>
  <div class="col-md-2 col-sm-2 col-lg-2 col-xl-2 col-xs-2 ">
    <span class="form-inline-new">
      <p class="forecast-service-headers">Unit of Measure</p>
    </span>
    <span>
      <p class="forecast-service-values">{{ selectedService?.Unit_Of_Measure }}</p>
    </span>
  </div>
  <div class="col-md-1 col-sm-1 col-lg-1 col-xl-1 col-xs-1 ">
    <span class="form-inline-new">
      <p class="forecast-service-headers">Rate</p>
    </span>
    <span>
      <p class="forecast-service-values">{{ selectedService?.Rate }}</p>
    </span>
  </div>
  <div class="col-md-2 col-sm-2 col-lg-2 col-xl-2 col-xs-2 ">
    <span class="form-inline-new">
      <p class="forecast-service-headers">Forecast Cycle</p>
    </span>
    <span>
      <p class="forecast-service-values">{{ forecastCycle?.Forecast_Cycle }}</p>
    </span>
  </div>
  <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12 mt-3">
    <mat-table [dataSource]="tableDataSource" class="mat-elevation-z8 table-container fc-service-table">
      @for (column of columns; track column) {
      <ng-container [matColumnDef]="column.label">
        <mat-header-cell *matHeaderCellDef> {{ column.label }} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          @if (element[column.disable_key]) {
          <span>
            {{ element[column.key] }}
          </span>
          } @if (!element[column.disable_key]) {
          <input
            class="forecast-add-input forecast-input-border"
            [disabled]="element[column.disable_key]"
            [(ngModel)]="element[column.key]"
            appIntegerOnly
            [allowNegative]="allowNegative"
            appDisableDragDrop
          />
          }
        </mat-cell>
      </ng-container>
      }
      <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>
      <mat-row *matRowDef="let row; columns: columnsToDisplay"></mat-row>
    </mat-table>
  </div>
</div>
<div class="pull-right">
  <button
    mat-mdc-raised-button
    [disabled]="disableApply"
    (click)="apply()"
    class="add-apply m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size"
  >
    Apply
  </button>
</div>
